import {Box, TextField, MenuItem} from '@mui/material';
import React, {useEffect} from 'react';
import {ANALYSIS_DESCRIPTION_MAX_CHARS, ANALYSIS_NAME_MAX_CHARS} from '../constants';

interface ChIPAnalysisDownStreamStep0Props {
    formData: {
        name: string;
        description: string;
        default_ChIP_analysis: string;
    };
    setFormData: React.Dispatch<React.SetStateAction<any>>;
    handleNext: (isValid: boolean) => void;
    error: string;
    setError?: (error: string) => void;
    ChIPDefaultAnalysisList: any[];
}

function ChIPAnalysisDownStreamStep0({
    formData,
    setFormData,
    handleNext,
    error,
    ChIPDefaultAnalysisList
}: ChIPAnalysisDownStreamStep0Props) {
    const handleInputChange = (e: any) => {
        const {name, value} = e.target;
        setFormData({...formData, [name]: value});
    };

    useEffect(() => {
        if (!formData.default_ChIP_analysis && ChIPDefaultAnalysisList?.length > 0) {
            setFormData({...formData, default_ChIP_analysis: ChIPDefaultAnalysisList[0].analysis_id});
        }
    }, [ChIPDefaultAnalysisList]);

    useEffect(() => {
        formData.name.trim().length > 2 && formData.default_ChIP_analysis && !error ? handleNext(true) : handleNext(false);
    }, [formData, error]);

    return (
        <Box
            p={3}
            my={1}
            sx={{bgcolor: 'surface-container-lowest', borderRadius: '10px', display: 'flex', flexDirection: 'column', gap: 3}}>
            <TextField
                name="name"
                label="Analysis Name"
                fullWidth
                value={formData.name}
                placeholder="Enter a name"
                onChange={handleInputChange}
                inputProps={{maxLength: ANALYSIS_NAME_MAX_CHARS}}
            />

            <TextField
                name="description"
                label="Description (optional)"
                fullWidth
                value={formData.description}
                placeholder="Enter a description"
                onChange={handleInputChange}
                inputProps={{maxLength: ANALYSIS_DESCRIPTION_MAX_CHARS}}
            />

            <TextField
                select
                name="default_ChIP_analysis"
                label="ChIP Default Analysis"
                fullWidth
                value={formData.default_ChIP_analysis || ''}
                onChange={handleInputChange}
                disabled={ChIPDefaultAnalysisList.length === 0}
                helperText={
                    ChIPDefaultAnalysisList.length === 0 && !error
                        ? 'Loading defaults...'
                        : 'Selecting a default analysis will import its calculated peaks into your new analysis.'
                }>
                {ChIPDefaultAnalysisList?.map((option: any) => (
                    <MenuItem key={option.analysis_id} value={option.analysis_id}>
                        {option.analysis_name}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
}

export default ChIPAnalysisDownStreamStep0;
